import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import apiConfig from "../config/apiConfig";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import Select from 'react-select';
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
  Input,
  Button,
  FormGroup,
  Label,
  Form,
} from "reactstrap";

function DiscountCode() {
  const [formData, setFormData] = useState({
    id: null, // برای ویرایش
    title: "",
    code: "",
    discountType: "percentage", // percentage یا amount
    percentage: "",
    amount: "",
    selectedUsers: [],
    expiryDate: "",
    maxUsage: "",
  });
  const [users, setUsers] = useState([]);
  const [discountCodes, setDiscountCodes] = useState([]);
  const [loading, setLoading] = useState(false);

  // دریافت لیست کاربران و کدهای تخفیف از API
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get(`${apiConfig.serverUrl}users`);
        setUsers(response.data.users);
      } catch (error) {
        toast.error("خطا در دریافت لیست کاربران: " + (error.response?.data?.message || error.message));
      }
    };

    const fetchDiscountCodes = async () => {
      try {
        const response = await axios.get(`${apiConfig.serverUrl}discount-codes`);
        setDiscountCodes(response.data.discount_codes);
      } catch (error) {
        toast.error("خطا در دریافت کدهای تخفیف: " + (error.response?.data?.message || error.message));
      }
    };

    fetchUsers();
    fetchDiscountCodes();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleUserChange = (selectedOptions) => {
    setFormData({ ...formData, selectedUsers: selectedOptions || [] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // اعتبارسنجی
    if (!formData.title || !formData.code) {
      toast.error("لطفاً تمام فیلدهای الزامی را پر کنید!");
      setLoading(false);
      return;
    }

    if (formData.discountType === "percentage") {
      if (!formData.percentage) {
        toast.error("لطفاً درصد تخفیف را وارد کنید!");
        setLoading(false);
        return;
      }
      if (formData.percentage < 0 || formData.percentage > 100) {
        toast.error("درصد تخفیف باید بین 0 تا 100 باشد!");
        setLoading(false);
        return;
      }
    } else if (formData.discountType === "amount") {
      if (!formData.amount) {
        toast.error("لطفاً مبلغ تخفیف را وارد کنید!");
        setLoading(false);
        return;
      }
      if (formData.amount < 0) {
        toast.error("مبلغ تخفیف باید بیشتر از 0 باشد!");
        setLoading(false);
        return;
      }
    }

    try {
      const url = formData.id
        ? `${apiConfig.serverUrl}discount-code/${formData.id}`
        : `${apiConfig.serverUrl}discount-code`;
      const method = formData.id ? 'put' : 'post';

      const response = await axios({
        method,
        url,
        data: {
          title: formData.title,
          code: formData.code,
          discount_type: formData.discountType,
          percentage: formData.discountType === "percentage" ? parseFloat(formData.percentage) : null,
          amount: formData.discountType === "amount" ? parseFloat(formData.amount) : null,
          user_ids: formData.selectedUsers.map(user => user.value),
          expiry_date: formData.expiryDate || null,
          max_usage: formData.maxUsage ? parseInt(formData.maxUsage) : null,
        },
        headers: {
          api_token: localStorage.getItem("user_token"),
        },
      });

      Swal.fire({
        title: "موفقیت!",
        text: formData.id ? "کد تخفیف با موفقیت ویرایش شد." : "کد تخفیف با موفقیت ثبت شد.",
        icon: "success",
        confirmButtonText: "باشه",
      });

      // به‌روزرسانی لیست کدهای تخفیف
      const updatedCodes = await axios.get(`${apiConfig.serverUrl}discount-codes`);
      setDiscountCodes(updatedCodes.data.discount_codes);

      // پاک کردن فرم
      setFormData({
        id: null,
        title: "",
        code: "",
        discountType: "percentage",
        percentage: "",
        amount: "",
        selectedUsers: [],
        expiryDate: "",
        maxUsage: "",
      });
    } catch (error) {
      toast.error("خطا در ثبت/ویرایش کد تخفیف: " + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (discountCode) => {
    setFormData({
      id: discountCode.id,
      title: discountCode.title,
      code: discountCode.code,
      discountType: discountCode.discount_type || "percentage",
      percentage: discountCode.percentage || "",
      amount: discountCode.amount || "",
      selectedUsers: discountCode.users.map(user => ({
        value: user.id,
        label: `${user.name} (${user.email})`,
      })),
      expiryDate: discountCode.expiry_date || "",
      maxUsage: discountCode.max_usage || "",
    });
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "آیا مطمئن هستید؟",
      text: "این کد تخفیف حذف خواهد شد!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "بله، حذف کن!",
      cancelButtonText: "خیر",
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(`${apiConfig.serverUrl}discount-code/${id}`, {
          headers: {
            api_token: localStorage.getItem("user_token"),
          },
        });
        Swal.fire({
          title: "حذف شد!",
          text: "کد تخفیف با موفقیت حذف شد.",
          icon: "success",
          confirmButtonText: "باشه",
        });
        // به‌روزرسانی لیست کدهای تخفیف
        const updatedCodes = await axios.get(`${apiConfig.serverUrl}discount-codes`);
        setDiscountCodes(updatedCodes.data.discount_codes);
      } catch (error) {
        toast.error("خطا در حذف کد تخفیف: " + (error.response?.data?.message || error.message));
      }
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="content" style={{ direction: "rtl", textAlign: "right" }}>
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">ایجاد/ویرایش کد تخفیف</CardTitle>
              </CardHeader>
              <CardBody>
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <Label for="title">عنوان کد تخفیف <span style={{ color: "red" }}>*</span></Label>
                        <Input
                          type="text"
                          name="title"
                          id="title"
                          placeholder="مثال: تخفیف ویژه تابستان"
                          value={formData.title}
                          onChange={handleInputChange}
                          required
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label for="code">کد تخفیف <span style={{ color: "red" }}>*</span></Label>
                        <Input
                          type="text"
                          name="code"
                          id="code"
                          placeholder="مثال: SUMMER20"
                          value={formData.code}
                          onChange={handleInputChange}
                          required
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <Label for="discountType">نوع تخفیف <span style={{ color: "red" }}>*</span></Label>
                        <Input
                          type="select"
                          name="discountType"
                          id="discountType"
                          value={formData.discountType}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="percentage">درصدی</option>
                          <option value="amount">مبلغی</option>
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label for="selectedUsers">اختصاص به کاربران (اختیاری)</Label>
                        <Select
                          isMulti
                          name="selectedUsers"
                          options={users}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          placeholder="کاربران را انتخاب کنید..."
                          value={formData.selectedUsers}
                          onChange={handleUserChange}
                          noOptionsMessage={() => "کاربری یافت نشد"}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    {formData.discountType === "percentage" ? (
                      <Col md="6">
                        <FormGroup>
                          <Label for="percentage">درصد تخفیف <span style={{ color: "red" }}>*</span></Label>
                          <Input
                            type="number"
                            name="percentage"
                            id="percentage"
                            placeholder="مثال: 20"
                            value={formData.percentage}
                            onChange={handleInputChange}
                            min="0"
                            max="100"
                            required
                          />
                        </FormGroup>
                      </Col>
                    ) : (
                      <Col md="6">
                        <FormGroup>
                          <Label for="amount">مبلغ تخفیف (دلار) <span style={{ color: "red" }}>*</span></Label>
                          <Input
                            type="number"
                            name="amount"
                            id="amount"
                            placeholder="مثال: 50"
                            value={formData.amount}
                            onChange={handleInputChange}
                            min="0"
                            required
                          />
                        </FormGroup>
                      </Col>
                    )}
                  </Row>
                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <Label for="expiryDate">تاریخ انقضا (اختیاری)</Label>
                        <Input
                          type="date"
                          name="expiryDate"
                          id="expiryDate"
                          value={formData.expiryDate}
                          onChange={handleInputChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label for="maxUsage">حداکثر استفاده (اختیاری)</Label>
                        <Input
                          type="number"
                          name="maxUsage"
                          id="maxUsage"
                          placeholder="مثال: 100"
                          value={formData.maxUsage}
                          onChange={handleInputChange}
                          min="1"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Button
                    color="primary"
                    type="submit"
                    disabled={loading}
                    style={{ marginTop: "20px" }}
                  >
                    {loading ? "در حال ثبت..." : formData.id ? "ویرایش کد تخفیف" : "ثبت کد تخفیف"}
                  </Button>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">لیست کدهای تخفیف</CardTitle>
              </CardHeader>
              <CardBody>
                <Table responsive>
                  <thead className="text-primary">
                    <tr>
                      <th>عنوان</th>
                      <th>کد</th>
                      <th>نوع تخفیف</th>
                      <th>مقدار تخفیف</th>
                      <th>تاریخ انقضا</th>
                      <th>حداکثر استفاده</th>
                      <th>کاربران</th>
                      <th>عملیات</th>
                    </tr>
                  </thead>
                  <tbody>
                    {discountCodes.map((code) => (
                      <tr key={code.id}>
                        <td>{code.title}</td>
                        <td>{code.code}</td>
                        <td>{code.discount_type === "amount" ? "مبلغی" : "درصدی"}</td>
                        <td>
                          {code.discount_type === "amount" 
                            ? parseFloat(code.amount || 0).toLocaleString()
                            : `${code.percentage || 0}%`}
                        </td>
                        <td>{code.expiry_date || "بدون انقضا"}</td>
                        <td>{code.max_usage || "نامحدود"}</td>
                        <td>
                          {code.users.length > 0
                            ? code.users.map(user => `${user.name} (${user.email})`).join(", ")
                            : "بدون کاربر"}
                        </td>
                        <td>
                          <Button
                            color="info"
                            size="sm"
                            onClick={() => handleEdit(code)}
                            style={{ marginLeft: "5px" }}
                          >
                            ویرایش
                          </Button>
                          <Button
                            color="danger"
                            size="sm"
                            onClick={() => handleDelete(code.id)}
                          >
                            حذف
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default DiscountCode;